import InnoIcons from "@InnoIcons/";
import theme from "@theme/";
import styled from "styled-components";

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const BodyContainerg = styled.div`
  margin-top: 50px;
`;

const FilterContainer = styled.div`
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);
  padding: 16px 24px;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
`;
const LeasingLayout = styled.div`
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;

const BodyContainer = styled.div`
  margin-top: 50px;
`;

const CardContainer = styled.div`
  background-color: #feeac6;
  padding: 10px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  font-weight: bold;
  font-size: 1rem;
  background-color: #999;
  color: white;
  padding: 8px;
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 10px;
  background-color: #d5d5d5;
  font-weight: bold;
  font-size: 0.9rem;
  border-bottom: 1px solid #aaa;
  border-radius: 10px 10px 0px 0px;
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  margin: 15px 0px 10px 0px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.01);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
  }
`;

const HighlightText = styled.span`
  color: ${theme.colors.themeColor};
  font-style: italic;
`;

const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

const ColumnMore = styled.div`
  width: 60px;
`;

const ColumnDescription = styled.div`
  flex: 1;
`;

const ColumnSize = styled.div`
  width: 100px;
  text-align: left;
  font-size: 0.9rem;
`;

const ColumnDate = styled.div`
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  text-align: left;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ColumnCart = styled.div`
  width: 60px;
  text-align: center;
`;

const SearchSummaryContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 30px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  margin: 10px;
  border: 1px solid ${theme.colors.bordertask};
`;

const SummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const SearchSummary = styled.div`
  font-size: 1rem;
  // margin-bottom: 12px;
  color: ${theme.colors.themeColor};
  display: flex;
  align-items: center;
  gap: 4px;
`;

const TotalRecord = styled.p`
  font-size: 13px;
  margin: 0;
  margin-top: 4px;
  color: #666;
`;

const Keyword = styled.p`
  font-size: 13px;
  margin: 0;
  color: #666;
`;

const KeywordSpan = styled.span`
  font-style: italic;
  color: ${theme.colors.themeColor};
`;

const ChildContainer = styled.div``;
const Span = styled.span``;

const FileName = styled.span`
  font-size: 0.9rem;
  color: #4b5563;
  font-weight: normal;
  font-style: italic;
`;

const Note = styled.span`
  font-size: 13px;
  color: #4b5563;
`;

const NoDataMessage = styled.div`
  text-align: center;
  padding: 40px 0;
  font-size: 16px;
  color: #999999;
`;

const SC = {
  BodyHeader,
  BodyContainerg,
  FilterContainer,
  LeasingLayout,
  BodyHeader,
  Container,
  HeadingTag,
  BodyContainer,
  CardContainer,
  Header,
  TopRow,
  Content,
  HighlightText,
  RowWrapper,
  ColumnMore,
  ColumnDescription,
  ColumnSize,
  ColumnDate,
  ColumnCart,
  SearchSummaryContainer,
  SummaryContainer,
  SearchSummary,
  TotalRecord,
  Keyword,
  KeywordSpan,
  ChildContainer,
  Span,
  FileName,
  Note,
  NoDataMessage,
};

export default SC;
